export default "__VITE_ASSET__58836468__"